import React, { useState, useEffect } from "react";
import Preloader from "../../../shared/PreLoaders";
import { Row, Col } from "react-bootstrap";
import axios from "axios";
import { Authorization } from "../../../Context/Authorization";
import TableComponent from "../../../utils/TableComponent";

const VFCStatus = () => {
  const [loading, setLoading] = useState(true);
  const [ecMeetings, setEcMeetings] = useState([]);
  const [generalBodyMeetings, setGeneralBodyMeetings] = useState([]);
  const [pendingAudits, setPendingAudits] = useState([]);
  const [pendingRenewals, setPendingRenewals] = useState([]);

  const Api = process.env.REACT_APP_API;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const config = Authorization();

        const [meetingsRes, auditsRes] = await Promise.all([
          axios.get(`${Api}/api/vfc/pending/meetings`, config),
          axios.get(`${Api}/api/audits/pending-audits-renewals`, config),
        ]);

        setEcMeetings(meetingsRes.data.ecPendingMeetings);
        setGeneralBodyMeetings(meetingsRes.data.generalBodyPendingMeetings);
        setPendingAudits(auditsRes.data.pendingAudits || []);
        setPendingRenewals(auditsRes.data.pendingRenewals || []);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const columns = [
    {
      headerName: "SI.No",
      field: "index",
      valueGetter: (params) => params.node.rowIndex + 1,
    },
    {
      headerName: "VFC Name",
      field: "vfcName",
    },
    {
      headerName: "Meeting Date",
      field: "lastMeetingHeld",
    },
    {
      headerName: "Status",
      field: "status",
      cellStyle: (params) => {
        return params.value === "Inactive"
          ? { color: "red", fontWeight: "bold" }
          : {};
      },
      valueGetter: (params) =>
        params.data.lastMeetingHeld ? "Active" : "Inactive",
    },
  ];
  const auditColumns = [
    {
      headerName: "SI.No",
      field: "index",
      valueGetter: (params) => params.node.rowIndex + 1,
    },
    { headerName: "VFC Name", field: "vfcName" },
    { headerName: "Last Audit", field: "lastAuditDate" },
  ];

  const renewalColumns = [
    {
      headerName: "SI.No",
      field: "index",
      valueGetter: (params) => params.node.rowIndex + 1,
    },
    { headerName: "VFC Name", field: "vfcName" },
    { headerName: "Last Renewal", field: "lastRenewalDate" },
  ];

  return (
    <div>
      <Preloader loading={loading} />
      <div className="page-header">
        <h3 className="page-title">VFC Status</h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="!#" onClick={(event) => event.preventDefault()}>
                VFC
              </a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              VFC Status
            </li>
          </ol>
        </nav>
      </div>

      <div>
        <Row>
          <Col md={6}>
            <p className="breadcrumb-item active">EC Meetings Pending</p>
            <div className="card">
              <div className="card-body">
                <div className="table-responsive">
                  <TableComponent data={ecMeetings} columns={columns} />
                </div>
              </div>
            </div>
          </Col>

          {/* General Body Meetings Pending Table */}
          <Col md={6}>
            <p className="breadcrumb-item active">
              General Body Meetings Pending
            </p>
            <div className="card">
              <div className="card-body">
                <div className="table-responsive">
                  <TableComponent
                    data={generalBodyMeetings}
                    columns={columns}
                  />
                </div>
              </div>
            </div>
          </Col>

          <Col md={6}>
            <p className="breadcrumb-item active">Pending Audits</p>
            <div className="card">
              <div className="card-body">
                <div className="table-responsive">
                  <TableComponent data={pendingAudits} columns={auditColumns} />
                </div>
              </div>
            </div>
          </Col>

          <Col md={6}>
            <p className="breadcrumb-item active">Pending Renewals</p>
            <div className="card">
              <div className="card-body">
                <div className="table-responsive">
                  <TableComponent
                    data={pendingRenewals}
                    columns={renewalColumns}
                  />
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default VFCStatus;
